// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__widgets__SideBarHeader__root","leftIcon":"CentricUI__widgets__SideBarHeader__leftIcon","darkIcon":"CentricUI__widgets__SideBarHeader__darkIcon","selected":"CentricUI__widgets__SideBarHeader__selected","titleIcon":"CentricUI__widgets__SideBarHeader__titleIcon","tabs":"CentricUI__widgets__SideBarHeader__tabs","indicator":"CentricUI__widgets__SideBarHeader__indicator","title":"CentricUI__widgets__SideBarHeader__title","long":"CentricUI__widgets__SideBarHeader__long","titleMenu":"CentricUI__widgets__SideBarHeader__titleMenu"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/ui/widgets/SideBarHeader.css
// module id = 682
// module chunks = 10